/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import EnumStationType from 'src/enums/enumStationType';
import DatePicker from 'src/types/iview/DatePicker';
import CompleteLog from '../completeLog';
import DataCompleteApi, { DataCompleteDOI } from '../api/completLogApi';

export default class CompleteLogService extends ListPageService {
    ctx: CompleteLog;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

	constructor (ctx: CompleteLog) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		return [
			{
				headerName: '数据时间',
				field: 'data_time',
				minWidth: 160
            },
            {
				headerName: '补遗时间',
				field: 'addendum_time',
				minWidth: 160
            },
            {
				headerName: '补遗人',
				field: 'addendum_user',
				minWidth: 160
			},
		]
	}

    @override
	createBtnGroup (): Array<IconBtnItem> {
		return []
	}

    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
				component: DatePicker,
				label: '时间',
                field: 'time',
                width: 300,
                realField: ['start_time','end_time'],
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
            }
                
        ];
    }


	@override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<DataCompleteDOI.QueryRowDataParamsI>(),
            mn: this.ctx.mn,
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await DataCompleteApi.searchLog({
            ...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
		}
    }

}